import React, { Fragment } from 'react';
import {
  ChoiceList,
  Tag,
  TextField,
  Box
} from '@shopify/polaris';
import {useState, useEffect, useCallback} from 'react';
import intl from '../../i18n/intl';
import './index.css'
export default function NotImportedBulkEdit(props) {
  const { type, option, getOption, showTip } = props
  const [selected, setSelected] = useState([]); // 选中多选框的值
  const [selectedTags, setSelectedTags] = useState(Boolean(option?.length) ? option : []); // 选中的批量编辑标签的值
  const [changeDomType, setChangeDomType] = useState(true); // 切换dom类型 input tag
  const [tagText, setTagText] = useState(''); // 标签内容
  const [showAddBtn, setShowAddBtn] = useState(true); // 是否显示添加按钮

  const handleChange = (value) => {
    setSelected(value)
  }

  // 删除标签
  const removeTag = (tag) => () => {
    setSelectedTags((previousTags) =>
      previousTags.filter((previousTag) => previousTag !== tag),
    );
    type === 'product type' && setShowAddBtn(true)
  }

  // 标签组件
  const tagMarkup = selectedTags.map((option) => (
    <Tag style={{marginRight:'8px'}} key={option} onRemove={removeTag(option)}>
      {option}
    </Tag>
  ));
  
  // 标签文本改变事件
  const handleTextChange = (value) => {
    // 超过50个字符则 提示
    if (value.trim() === '') {
      return
    }
    if(value.length <= 50) {
      setTagText(value)
    }
  }

  // 标签文本框聚焦事件
  const handleFocus = 
  useCallback(
    (val) => {
      if (val.trim() === '') {
        return
      }
      !Boolean(val) && setTagText('')
    },
    [],
  );

  // 标签文本框失焦事件
  const handleBlur = (value) => {
    let arr = selectedTags
    if (value.trim() === '') {
      return
    }
    if(selectedTags.indexOf(value) === -1) {
      arr.push(value)
      setShowAddBtn(arr.length === 1 && type === 'product type' ? false : true)
      setTagText('')
      setSelectedTags(arr);
    } else {
      showTip("Tag already exists.", false) // 提示 标签已存在
      setChangeDomType(!changeDomType)
    }
  }

  useEffect(() => {
    type === 'collections' ? getOption(selected) : getOption(selectedTags)
  }, [selected, selectedTags, getOption, type]);

  return type === 'collections' ? <ChoiceList
    allowMultiple
    title={intl.get("Please select collections.")}
    choices={option}
    selected={selected}
    onChange={handleChange}
  /> : <Fragment>
    <div className="tag_title">
      {type === 'tags' ? intl.get("Please Add tags.") : intl.get("Please add product type.")}
    </div>
    <div className={showAddBtn ? `tag_content` : `tag_content_once`}>
      <Box>
        {tagMarkup}
        {showAddBtn ?
        (changeDomType ? 
        <Tag onClick={() => setChangeDomType(!changeDomType)}>+</Tag> : 
        <TextField
          value={tagText}
          onChange={handleTextChange}
          focused={!changeDomType}
          onFocus={() => {!changeDomType && handleFocus(tagText)}}
          onBlur={() => {
            if(!changeDomType) {
              setChangeDomType(!changeDomType);
              handleBlur(tagText)
            }
          }}
          label=""
          type="text"
          autoComplete="text"
        />) : null}
      </Box>
    </div>
  </Fragment>;
}